<ul class="m-0 list-inline d-flex justify-content-between align-items-center">
  @for (step of steps; track step.id) {
    <li>
      <button
        class="step-button btn border"
        [disabled]="step.disabled"
        (click)="onSelectStep.emit(step.id)"
        [ngClass]="step.id === selectedStep ? 'btn-nz-primary' : 'btn-light'">
        <h5 class="m-0"> {{ step.id }}</h5>
      </button>
    </li>
    @if ($index < steps.length - 1) {
      <li class="w-100 p-2">
        <hr>
      </li>
    }
  }
</ul>
